import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "field p-3" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}

import { ref, computed } from 'vue';
import InputText from 'primevue/inputtext';


export default /*#__PURE__*/_defineComponent({
  emits: ["submit"],
  setup(__props, { expose, emit }: { emit: ({ (e: 'submit', payload: { email: string }): void }), expose: any, slots: any, attrs: any }) {



const email = ref('');
const submitted = ref(false);

const emailError = computed(() => (submitted.value && !email.value.trim()) ? 'Email is required' : '');

const submit = () => {
  submitted.value = true;
  if (emailError.value) return false;
  emit('submit', { email: email.value });
  return true;
};

expose({ submit });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(InputText), {
        modelValue: email.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
        id: "email",
        class: _normalizeClass({ 'p-invalid': !!_unref(emailError) })
      }, null, 8, ["modelValue", "class"]),
      _hoisted_3
    ]),
    (_unref(emailError))
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_unref(emailError)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})